import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NotificationSize, NotificationType } from '../models.js';

var PREFIX = "Notification";
var classes = {
    progress: "".concat(PREFIX, "-progress"),
    progressBar: "".concat(PREFIX, "-progressBar"),
    close: "".concat(PREFIX, "-close"),
    content: "".concat(PREFIX, "-content"),
    actions: "".concat(PREFIX, "-action"),
    dismiss: "".concat(PREFIX, "-dismiss")
};
var sizeCalc = function (size) {
    switch (size) {
        case NotificationSize.Small:
            return 30;
        case NotificationSize.Large:
            return 60;
        default:
            return 40;
    }
};
var color = function (type, theme) {
    switch (type) {
        case NotificationType.Alert:
            return theme.palette.error.main;
        case NotificationType.Warning:
            return theme.palette.warning.main;
        case NotificationType.Info:
            return theme.palette.info.main;
        case NotificationType.Success:
            return theme.palette.success.main;
        default:
            return theme.palette.primary.main;
    }
};
var StyledNotification = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "size" && prop !== "type"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, _c = _a.size, size = _c === void 0 ? NotificationSize.Medium : _c, _d = _a.type, type = _d === void 0 ? NotificationType.Primary : _d;
    return (_b = {
            width: theme.spacing(sizeCalc(size)),
            maxWidth: "calc(100vw - ".concat(theme.spacing(4), ")"),
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            border: "1px solid",
            borderColor: color(type, theme),
            boxShadow: theme.shadows[3],
            background: theme.palette.background["default"]
        },
        _b["& .".concat(classes.progress)] = {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            borderTopRightRadius: theme.spacing(0.25),
            borderTopLeftRadius: theme.spacing(0.25),
            backgroundColor: alpha(color(type, theme), 0.25),
            height: theme.spacing(0.5)
        },
        _b["& .".concat(classes.progressBar)] = {
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: color(type, theme),
            height: "100%"
        },
        _b["& .".concat(classes.close)] = {},
        _b["& .".concat(classes.content)] = {
            padding: theme.spacing(1)
        },
        _b["& .".concat(classes.actions)] = {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(1)
        },
        _b["& .".concat(classes.dismiss)] = {
            marginRight: theme.spacing(1)
        },
        _b);
});

export { classes, StyledNotification as default };
//# sourceMappingURL=index.styled.js.map
